module.exports = __webpack_public_path__ + "static/media/es-ga.b3da1c5c.svg";